<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		:persistent="waitingForServerResponse"
		@click:outside="handleDismiss"
		@keydown.esc="handleDismiss"
	>
		<v-card>
			<v-card-title class="dialog-header sgnl-subtitle-medium"> Disconnect "{{ driveData.Name }}"? </v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<p>Would you like to disconnect data drive "{{ driveData.Name }}"?</p>
				<v-alert
					:icon="false"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					<strong>This operation can not be undone.</strong>
				</v-alert>
				<v-alert
					v-if="showError"
					:icon="false"
					border="start"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					{{ errorMessage }}
				</v-alert>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="handleDismiss"
				>
					Cancel
				</v-btn>
				<v-btn
					variant="flat"
					color="error"
					:loading="waitingForServerResponse"
					@click="commitDisconnect"
				>
					Disconnect
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { sdk } from "@/js/sdk";
import { SdkError } from "@signaloid/cloud-compute-engine-client";
import axios from "axios";
import { monitoringCaptureError } from "@/plugins/monitoring";

export default defineComponent({
	name: "DisconnectDriveDialog",
	emits: ["update:showDialog", "drive-disconnected", "close-dialog"],
	props: {
		showDialog: Boolean,
		driveData: Object,
	},
	data: () => ({
		waitingForServerResponse: false,
		errorMessage: "unknown error",
		showError: false,
	}),
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		async commitDisconnect() {
			this.errorMessage = undefined;
			this.showError = false;
			try {
				this.waitingForServerResponse = true;
				await sdk.drives.delete(this.driveData.DriveID);
				this.$emit("drive-disconnected");
				this.closeDialog();
			} catch (error) {
				monitoringCaptureError(error, "Disconnect drive");
				if (error instanceof SdkError) {
					this.errorMessage = "An error occurred while disconnecting the drive.";
				} else if (axios.isAxiosError(error)) {
					this.errorMessage =
						"Failed to disconnect the drive. Make sure you have an active internet connection.";
				} else {
					this.errorMessage = "An error occurred while disconnecting the drive.";
				}
				this.showError = true;
			} finally {
				this.waitingForServerResponse = false;
			}
		},
		handleDismiss() {
			if (this.waitingForServerResponse) {
				return;
			}
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("close-dialog");
		},
	},
});
</script>
